module.exports = (__webpack_require__(1))(47);


//////////////////
// WEBPACK FOOTER
// delegated ./node_modules/process/browser.js from dll-reference core_library
// module id = 19
// module chunks = 5 6 7 8 9 10